import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import moment from 'moment';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../../../layouts/SnackBars';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  controlLabel: {
    width: 300
  },
  button: {
    margin: theme.spacing(1),
    width: 130,
    textAlign: 'left',
  },
  formControl: {
    marginTop: 5
  }
}));

const SlipDataLoad = props => {
  const classes = useStyles();
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState();
  const [snackVariant, setSnackVariant] = useState('success');

  const { moneyTypes, typePersons, budgetYears, getLoadValue } = props;
  const [deduct, SetDeduct] = useState('');
  const [deduct1, SetDeduct1] = useState('');
  const [deduct2, SetDeduct2] = useState('');
  const [checkDeduct1, SetCheckDeduct1] = useState(true);
  const [checkDeduct2, SetCheckDeduct2] = useState(true);
  const [deductType, SetDeductType] = useState('');

  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };

  const handleChange = event => {
    if (event.target.name === 'DeductType') {
      if (parseInt(event.target.value) === 2) {
        SetCheckDeduct1(false);
        SetCheckDeduct2(true);
        SetDeduct2('');
      }
      else if (parseInt(event.target.value) === 3) {
        SetCheckDeduct2(false);
        SetCheckDeduct1(true);
        SetDeduct1('');
      }
      else {
        SetCheckDeduct2(true);
        SetCheckDeduct1(true);
        SetDeduct1('');
        SetDeduct2('');
      }
      SetDeductType(event.target.value);
    }
  };

  let source = axios.CancelToken.source();

  useEffect(() => {
    const fetchData = async () => {
      try {



        /*await getFinanceUser(financeuser, data);
       return () => {
         source.cancel();
       };*/
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, [moneyTypes, typePersons]);

  const getValue = value => (typeof value === 'string' ? value.toUpperCase() : value);

  const filter = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].find(filter => getValue(filter) === getValue(item[key]));
      });
    });
  }

  const getMoneyType = (oldMoneyType) => {
    let value = [];
    oldMoneyType.map((key, index) => {
      (key.field !== 'fullname' && key.field !== 'citizen_id' && key.field !== 'bank_account' && key.field !== 'project_activities_id' && key.field !== 'bank_name' && key.field !== 'position_num') && (
        value.push(parseInt(key.field))
      )
    });
    return value;
  }

  const getPersons = (OldPerson) => {
    let value = [];
    OldPerson.map((key, index) => {
      value.push(key.citizen_id)
    });
    return value;
  }

  const loadSlipData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/slipByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const loadEtcData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/etcByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)

    } catch (error) {

    }
  };

  const loadPersonData = async (typePerson) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/users/personsByType/' + typePerson;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  const SaveData = async () => {
    const currentDate = new Date(budgetYears);
    const OldDate = moment(currentDate.setMonth(currentDate.getMonth() - 1)).format('YYYY-MM-DD');
    let slipData = await loadSlipData(OldDate);
    let etcdata = await loadEtcData(OldDate);
    let newSlipData = [];
    const persons = await loadPersonData(typePersons);
    let selectMoneyType = getMoneyType(moneyTypes);
    let selectPersons = getPersons(persons);
    slipData = filter(slipData, { money_type_id: selectMoneyType });
    slipData = filter(slipData, { citizen_id: selectPersons });
    //etcdata = filter(etcdata, { citizen_id: selectPersons });

    if (parseInt(deductType) === 2) {
      slipData.map((key, index) => {
        newSlipData.push({
          citizen_id: key.citizen_id,
          money_type_id: key.money_type_id,
          eslip_value: parseFloat(DebtCal(key.eslip_value, deduct1)),
          payslip_for: budgetYears
        })
      });
    }
    else if (parseInt(deductType) === 3) {
      slipData.map((key, index) => {
        newSlipData.push({
          citizen_id: key.citizen_id,
          money_type_id: key.money_type_id,
          eslip_value: parseFloat(deduct2),
          payslip_for: budgetYears
        })
      });
    }
    else if (parseInt(deductType) === 4) {
      etcdata.map((key, index) => {
        newSlipData.push({
          citizen_id: key.citizen_id,
          bank_name: key.bank_name,
          bank_account: key.bank_account,
          project_activities_id: key.project_activities_id,
          payslip_for: budgetYears
        })
      });
    }
    else {
      slipData.map((key, index) => {
        newSlipData.push({
          citizen_id: key.citizen_id,
          money_type_id: key.money_type_id,
          eslip_value: key.eslip_value,
          payslip_for: budgetYears
        })
      });
    }
    try {
      if (parseInt(deductType) === 4) {
        //console.log(newSlipData)
        const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteEtcAllData/';
        await axios.post(apiUrl1, { payslip_for: budgetYears });
        const apiUrl = 'https://eslip.snru.ac.th/backend/api/eslipData/saveEtcData';
        await axios.post(apiUrl, newSlipData);
      }
      else {
        //console.log(selectMoneyType)
       /* selectMoneyType.forEach(element => {
          const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteDataByMonth';
          axios.post(apiUrl1, { money_type_id: selectMoneyType, citizen_id: selectPersons, payslip_for: budgetYears });
        });*/

        const apiUrl2 = 'https://eslip.snru.ac.th/backend/api/eslipData/saveMultiData';
        await axios.post(apiUrl2, newSlipData);
      }

      setSnackVariant('success');
      setSnackMessage('บันทึกข้อมูลแแล้ว');
      setOpenSnack(true);
      getLoadValue(newSlipData);
    } catch (error) {
      setSnackVariant('error');
      setSnackMessage(error.response.data.error.message)
      setOpenSnack(true);
    }
  }

  const DeleteData = async () => {
    let selectMoneyType = getMoneyType(moneyTypes);
    try {
      selectMoneyType.forEach(element => {
        const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteDataByMonth';
        axios.post(apiUrl1, { money_type_id: element, payslip_for: budgetYears });
      });

      setSnackVariant('success');
      setSnackMessage('ลบข้อมูลแแล้ว');
      getLoadValue([]);
    } catch (error) {
      setSnackVariant('error');
      setSnackMessage(error.response.data.error.message)
      setOpenSnack(true);
    }
  }

  const DebtCal = (Olddebt, Interest) => {
    let Newdebt = 0;
    let principle = 0;
    let deposit = 0;
    let newDeposit = 0;
    let newInterest = 0;
    let finalDebt = 0;
    if (Olddebt > 50) {
      if (parseInt(Interest) === 1) {
        Newdebt = (Olddebt % 500);
        principle = Olddebt - Newdebt;
        deposit = Newdebt / (Interest / 100);
        newDeposit = deposit - principle;
        newInterest = newDeposit * (Interest / 100);
        finalDebt = (principle + newInterest);
      } else {
        Olddebt = Olddebt - 50;
        Newdebt = (Olddebt % 500);
        principle = Olddebt - Newdebt;
        deposit = Newdebt / (Interest / 100);
        newDeposit = deposit - principle;
        newInterest = newDeposit * (Interest / 100);
        finalDebt = (principle + newInterest) + 50;
      }
    } else {
      finalDebt = Olddebt;
    }
    return finalDebt;
  }



  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={9}>
          <FormControl component="fieldset">
            <FormLabel component="legend"><h3>ดึงข้อมูลเดิมเดือนที่แล้ว</h3></FormLabel>
            <RadioGroup aria-label="position" name="DeductType" value={deductType} onChange={handleChange} row>
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label={
                  <TextField
                    label="ดึงข้อมูลเดิม"
                    defaultValue="เดือนที่ผ่านมา"
                    name="deduct_1"
                    className={classes.textField}
                    margin="normal"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                }
                labelPlacement="end"
              />
              <FormControlLabel
                value="2"
                control={<Radio color="primary" />}
                label={
                  <TextField
                    onChange={handleChange}
                    label="ลดต้นลดดอก ระบุดอกเบี้ย (%)"
                    value={deduct1}
                    onChange={(e) => SetDeduct1(e.target.value)}
                    type="number"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: checkDeduct1,
                    }}
                    margin="normal"
                  />
                }
                labelPlacement="end"
              />
              <FormControlLabel
                value="3"
                control={<Radio color="primary" />}
                label={
                  <TextField
                    onChange={handleChange}
                    label="ระบุยอดหัก (บาท)xxx"
                    value={deduct2}
                    onChange={(e) => SetDeduct2(e.target.value)}
                    type="number"
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: checkDeduct2,
                    }}
                    margin="normal"
                  />
                }
                labelPlacement="end"
              />
              <FormControlLabel
                value="4"
                control={<Radio color="primary" />}
                label={
                  <TextField
                    onChange={handleChange}
                    label="ดึงเลขที่บัญชี รหัสโครงการ"
                    defaultValue="เดือนที่ผ่านมา"
                    name="deduct_1"
                    className={classes.textField}
                    margin="normal"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                }
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs>
          <div >
            <Button variant="contained" className={classes.button} color="primary" onClick={SaveData} spacing={3}>
              <SaveIcon className={clsx(classes.leftIcon, classes.iconSmall)} />ดึงข้อมูล
          </Button>
            <Button variant="contained" className={classes.button} color="default" onClick={DeleteData} spacing={3}>
              <DeleteIcon className={clsx(classes.leftIcon, classes.iconSmall)} />ลบข้อมูล
          </Button>
          </div>

        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackVariant}
          message={snackMessage}
        />
      </Snackbar>
    </div>
  );
};

SlipDataLoad.propTypes = {
  budgetYears: PropTypes.string,
  typePersons: PropTypes.array,
  moneyTypes: PropTypes.array,
  getLoadValue: PropTypes.func
};

export default SlipDataLoad;